export const listenToQuestion = (question: string) => {
  if (question) {
    if ('speechSynthesis' in window) {
      const utterance = new SpeechSynthesisUtterance(question);
      utterance.rate = 0.8;
      window.speechSynthesis.speak(utterance);
    } else {
      console.log('SpeechSynthesis is not supported in this browser.');
    }
  }
};
